import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Guid } from 'guid-typescript';
import { CrossSellingService } from 'src/app/api/services/crossSelling.service';
import * as fromCrossSelling from 'src/app/core/state/cross-selling';
import * as fromRoot from '../../core/state/core.state';
import { ROOT_PATH, CROSS_SELLING_PATH } from '../constants/route.constants';
import { CrossSellingQuestionVm } from 'src/app/api/models/crossSellingQuestionVm.model';
import { CrossSellingInformationVm } from 'src/app/api/models/crossSellingInformationVm.model';

@Injectable({
  providedIn: 'root'
})
export class CrossSellingQuestionsService {
  constructor(
    private crossSellingService: CrossSellingService,
    private store: Store<fromRoot.State>,
    private router: Router
  ) {}

  public processQuestions(agreementId: string, salesChannel: string) {
    this.crossSellingService.getQuestions(agreementId, salesChannel).subscribe(data => {
      this.dispatchQuestions(data);
      this.router.navigate([`${ROOT_PATH}${CROSS_SELLING_PATH}`]);
    });
  }

  private dispatchQuestions(data: CrossSellingInformationVm) {
    this.store.dispatch(fromCrossSelling.patchQuestions({ payload: { Information: data } }));
  }
}
